import React from 'react'

import {
  usePdfOptionsForm,
  usePdfOptionsFormActions
} from '../../../../../components/pdf/options/_form/PdfOptionsFormHandler'
import { FlexCol } from '../../../../../components/structure/FlexGrid'
import Accordion from '../../../../../components/structure/accordion/Accordion'
import AccordionHeader from '../../../../../components/structure/accordion/AccordionHeader'
import Grid from '../../../../../components/pdf/Grid'
import { Title } from '../../../../../components/presentation/Text'
import AccordionContent from '../../../../../components/structure/accordion/AccordionContent'
import { SwitchWithLabel } from '../../../../../components/form/Switch'

const ActivationDetails = () => {
  const form = usePdfOptionsForm()
  const { handleChange } = usePdfOptionsFormActions()

  return (
    <FlexCol>
      <Accordion lineBorder mediumPadding={true} noRadius>
        <AccordionHeader>
          <Grid justify="space-between">
            <Title size="h6" noMargin>
              Detalhes da Ativação
            </Title>
          </Grid>
        </AccordionHeader>
        <AccordionContent>
          <SwitchWithLabel
            label="Exibir detalhes da ativação"
            value={form.activationDetails}
            onChange={handleChange(`activationDetails`)}
          />
        </AccordionContent>
      </Accordion>
    </FlexCol>
  )
}

export default ActivationDetails
